module.exports = __webpack_public_path__ + "static/media/oliver.da7d7a5f.jpeg";